import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TASKS } from '@shared/api/endpoints';
import type { ApprovalDecision, ApprovalDecisionResponse } from '@tailorcast/shared-types';
import { ApiClientError } from '@shared/api/client';

export function useApprovalDecision() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      approvalId,
      decision,
      feedback,
      userEdit,
    }: {
      approvalId: string;
      decision: ApprovalDecision;
      feedback?: string;
      userEdit?: Record<string, unknown>;
    }) =>
      api.post<ApprovalDecisionResponse>(TASKS.APPROVAL_DECIDE(approvalId), {
        decision,
        feedback,
        userEdit,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['approvals'] });
      queryClient.invalidateQueries({ queryKey: ['tasks'] });
    },
    onError: (error) => {
      if (error instanceof ApiClientError && error.status === 409) {
        queryClient.invalidateQueries({ queryKey: ['approvals'] });
      }
    },
  });
}
